import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllNote(page,size,personSenderId?:number,personRecevierId?:number,categoryId?:number,isPrivate?:boolean,isPinned?:boolean){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Note,
      queryString:`page=${page}&size=${size}&personSenderId=${personSenderId}&personRecevierId=${personRecevierId}&categoryId=${categoryId}&isPrivate=${isPrivate}&isPinned=${isPinned}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdNote(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Note,
    },id);
    return await firstValueFrom(observable);
  }

  async getByIdNoteisPinned(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Note,
      action:"GetByIdNoteisPinned"
    },id);
    return await firstValueFrom(observable);
  }

  async createNote(note){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Note,
    },note);
    return await firstValueFrom(observable);
  }

  async updateNote(note){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Note,
    },note);
    return await firstValueFrom(observable);
  }
}
